let language = {
    FOOTER_QPMN_TITLE:"与我们保持联系",
    FOOTRT_FACEBOOK_HINT:"关注Facebook",
    FOOTRT_INSTAGRAM_HINT:"关注Instagram"
};

export { language }